import * as React from "react";
import HighlightPreferredStoreContainer from "../../../../components/HighlightPreferredStore/components/HighlightPreferredStore/HighlightPreferredStoreContainer.js";
import StoreFinderContainer from "../../../../components/StoreFinder/components/StoreFinder/StoreFinderContainer.js";
import { StoreFinderProvider } from "../../../../context/StoreFinder/context/StoreFinder/provider.js";
const StoresRoot = ({
  urls,
  googleMapsId,
  hidePhone,
  hideEmail,
  storeSearchFilters,
  stores
}) => {
  return /* @__PURE__ */ React.createElement(
    StoreFinderProvider,
    {
      googleMapsId,
      withUrlParams: true,
      hidePhone,
      hideEmail,
      initialStores: stores,
      isStoreFiltersButtonEnabled: true,
      urls
    },
    /* @__PURE__ */ React.createElement("style", { jsx: true, global: true }, `
        .banner,
        .notification-bar {
          position: relative;
          z-index: 100;
        }
      `),
    /* @__PURE__ */ React.createElement(
      StoreFinderContainer,
      {
        highlightPreferredStore: /* @__PURE__ */ React.createElement(HighlightPreferredStoreContainer, null),
        storeSearchFilters,
        showAttributesAsTags: true
      }
    )
  );
};
export {
  StoresRoot as default
};
//# sourceMappingURL=StoresRoot.js.map
